import React from 'react';
import { HashRouter, Routes, Route } from 'react-router-dom';
import { ScrollToTop } from './components/ScrollToTop';
import { Header } from './components/Header';
import { HomePage } from './pages/HomePage';
import { CasinoPage } from './pages/CasinoPage';
import { RestaurantPage } from './pages/RestaurantPage';
import { HotelPage } from './pages/HotelPage';
import { TruckParkingPage } from './pages/TruckParkingPage';
import { TankstellePage } from './pages/TankstellePage';
import { ChargingPage } from './pages/ChargingPage';
export function App() {
  return <HashRouter data-id="element-0">
      <ScrollToTop data-id="element-1" />
      <Header data-id="element-2" />
      <div className="min-h-screen w-full bg-base text-gray-900 font-body selection:bg-electric-blue/30" data-id="element-3">
        <Routes data-id="element-4">
          <Route path="/" element={<HomePage data-id="element-6" />} data-id="element-5" />
          <Route path="/casino" element={<CasinoPage data-id="element-8" />} data-id="element-7" />
          <Route path="/restaurant" element={<RestaurantPage data-id="element-10" />} data-id="element-9" />
          <Route path="/hotel" element={<HotelPage data-id="element-12" />} data-id="element-11" />
          <Route path="/lkw-parken" element={<TruckParkingPage data-id="element-14" />} data-id="element-13" />
          <Route path="/tankstelle" element={<TankstellePage data-id="element-16" />} data-id="element-15" />
          <Route path="/ladesaeulen" element={<ChargingPage data-id="element-18" />} data-id="element-17" />
        </Routes>
      </div>
    </HashRouter>;
}